import Vue from 'vue';

export default {
    state:{
      tooltips:{
        tooltips:[],
        tooltip:{
          titulo:'',
          contenido:'',
          origen:'',
          suborigen:'',
          status:1
        }
      }
    },
    mutations: {
      setTooltips(state,tooltips){
        state.tooltips.tooltips=tooltips;
      },
      setTooltip_De_La_Seccion(state,tooltip){
        state.tooltips.tooltip=tooltip;
      },
    },
    actions: { 
      Consultar_Tooltips(context){
        $.getJSON(Vue.http.options.url_admin+"/tooltips", function(data, status){
            context.commit('setTooltips',data);
            context.dispatch('Definir_Tooltip_De_La_Seccion');
        });
      },
      Definir_Tooltip_De_La_Seccion(context){
        
        var nomseccion_menu   = context.rootState.menu.menu.opcion.name;
        if (context.rootState.menu.menu.opcion.origin1.name=="") {
          var origen_menu       = context.rootState.menu.menu.opcion.name;
        }else{
          var origen_menu       = context.rootState.menu.menu.opcion.origin1.name;
        }        
        var suborigen_menu    = context.rootState.menu.menu.opcion.origin2.name;
        var encontre= false;
        var titulo = '';
        var contenido='';

        for (var i = 0; i < context.state.tooltips.tooltips.length; i++) {
          var nomseccion_tooltip= context.state.tooltips.tooltips[i].nomseccion;
          var origen_tooltip    = context.state.tooltips.tooltips[i].origen;
          var suborigen_tooltip = context.state.tooltips.tooltips[i].suborigen;
          if (origen_tooltip==origen_menu && suborigen_menu==suborigen_tooltip && nomseccion_menu==nomseccion_tooltip) {
            
            encontre=true;
            context.commit('setTooltip_De_La_Seccion',context.state.tooltips.tooltips[i]);
            titulo = context.state.tooltips.tooltips[i].titulo;
            contenido = context.state.tooltips.tooltips[i].contenido;
          }
        }
        if (encontre) {
          $(document).ready(function(){
              $('#button_help').popover('hide');
              $('#breadcrumb_help').empty().append('<a data-trigger="hover" data-container="body"  id="button_help" style="color:#a1aab2 !important;" class="btn btn-link pt-1 pl-0" data-toggle="popover" title="'+titulo+'" data-content="'+contenido+'"><i class="fas fa-question-circle"></i></a>');
              $('[data-toggle="popover"]').popover();
          });
        }else{
          $(document).ready(function(){
              $('#button_help').popover('hide');
              $('#breadcrumb_help').empty();
            });
        }
      },
    },
    getters: {  
      getTooltips(state){
        return state.tooltips.tooltips;
      },
      getTooltip(state){
        return state.tooltips.tooltip;
      },
    },
    
}


// WEBPACK FOOTER //
// ./src/modules/tooltips.js